export const ADMIN_AUTH_ROUTES = {
  ADMIN_LOGIN: "api/v1/admin/login",
  USER_DETAILS: "api/v1/user/details",
  ADMIN_FP_SENDMAIL: "api/v1/admin/forgot-password",
  ADMIN_FP_RESENDMAIL: "api/v1/admin/resend-password",
  ADMIN_FP_RESET_PASSWORD: "api/v1/admin/reset-password",
  ADMIN_CHANGE_PASSWORD: "api/v1/admin/change-password",
  ADMIN_PROFILE: "api/v1/admin/user-profile",
  REFRESH_TOKEN: "api/v1/admin/refresh-token",
};

export const ADMIN_BLOG_ROUTES = {
  ADD_BLOG: "api/v1/admin/blogs",
  GET_BLOG: "api/v1/admin/blogs",
  UPDATE_STATUS_BLOG: "api/v1/admin/blogs",
  MULTIPLE_DELETE_BLOG: "api/v1/admin/multi-delete-blogs",
};

export const ADMIN_AMENITIES = {
  GET_ALL_AMENITIES: "api/v1/admin/amenity",
  ADD_AMENITIES: "api/v1/admin/amenity",
  UPDATE_AMENITIES: "api/v1/admin/amenity",
  DELETE_AMENITIES: "api/v1/admin/amenity",
};

export const ADMIN_MAIN_CATEGORY = {
  GET_ALL_CATEGORY: "api/v1/admin/categories",
  ADD_CATEGORY: "api/v1/admin/categories",
  DELETE_CATEGORY: "api/v1/admin/categories",
  UPDATE_CATEGORY: "api/v1/admin/categories",
  UPDATE_STATUS_CATEGORY: "api/v1/admin/categories",
  MULTIPLE_DELETE_CATEGORY: "api/v1/admin/delete-multiple-categories",
};

export const ADMIN_SUB_CATEGORY = {
  GET_ALL_SUB_CATEGORY: "api/v1/admin/sub-categories",
  ADD_SUB_CATEGORY: "api/v1/admin/sub-category",
  UPDATE_SUB_CATEGORY: "api/v1/admin/sub-category",
  UPDATE_STATUS_SUB_CATEGORY: "api/v1/admin/sub-category",
  MULTIPLE_DELETE_SUB_CATEGORY: "api/v1/admin/sub-categories",
};

export const ADMIN_IMAGE_CATEGORY_ROUTES = {
  GET_IMAGE_CATEGORY: "api/v1/admin/image/categories",
  MULTIPLE_DELETE_IMAGE_CATEGORY:
    "api/v1/admin/delete-multiple-image/categories",
};

export const ADMIN_FACT_FEATURES = {
  GET_ALL_FACT_FEATURES: "api/v1/admin/fact-and-feature",
  ADD_FACT_FEATURES: "api/v1/admin/fact-and-feature",
  DELETE_FACT_FEATURES: "api/v1/admin/fact-and-feature",
  UPDATE_FACT_FEATURES: "api/v1/admin/fact-and-feature",
  MULTIPLE_DELETE_FACT_FEATURE: "api/v1/admin/multiple-fact-and-feature",
};

export const ADMIN_APPLIANCES = {
  GET_ALL_APPLIANCES: "api/v1/admin/Appliances",
  ADD_APPLIANCES: "api/v1/admin/Appliances",
  DELETE_APPLIANCES: "api/v1/admin/Appliances",
  UPDATE_APPLIANCES: "api/v1/admin/Appliances",
};

export const ADMIN_CATEGORY_ROUTES = {
  GET_ALL_CATEGORY: "api/v1/admin/categories",
};

export const ADMIN_MANAGE_STAFF_ROLES = {
  ROLE: "api/v1/admin/role",
  MODULE_ACCESS: "api/v1/admin/modules/access?role_id=",
  GET_PERMISSION: "api/v1/admin/modules",
};

export const ADMIN_MANAGE_STAFF_ALL_STAFF = {
  GET_ALL_STAFF: "api/v1/admin/staff",
  CREATE_STAFF: "api/v1/admin/staff",
  UPDATE_STAFF: "api/v1/admin/staff",
  DELETE_STAFF: "api/v1/admin/delete-staff",
  CHANGE_STATUS_STAFF: "api/v1/admin/staff",
};

export const ADMIN_AGENT_ROUTES = {
  GET_AGENTS: "api/v1/admin/agents",
  GET_AGENT_BY_ID: "api/v1/admin/agents/",
  ADD_AGENT: "api/v1/admin/agents",
  DELETE_AGENT: "api/v1/admin/delete-agent",
};

export const ADMIN_CONTENT_MANAGEMENT = {
  GET_CMD: "api/v1/admin/cms",
};

export const ADMIN_PROPERTY_ROUTES = {
  ADD_PROPERTY: "api/v1/admin/properties",
  ADD_PROPERTY_IMAGE: "api/v1/admin/properties/images",
  POSITION_PROPERTY_IMAGE: "api/v1/admin/properties/images/position",
  DELETE_PROPERTY_IMAGE: "api/v1/admin/properties/images/delete",
  UPLOAD_RERA_DOCUMENT: "api/v1/admin/properties/rera-document",
  GET_ALL_PROPERTIES: "api/v1/admin/properties",
  DELETE_PROPERTY: "api/v1/admin/delete-property",
  ASSIGN_AGENT: "api/v1/admin/assign-agent",
  UNASSIGN_AGENT: "api/v1/admin/unassign-agent",
  MULTIPLE_DELETE_PROPERTY: "api/v1/admin/soft-delete-properties",
};

export const ADMIN_DROPDOWN_ROUTES = {
  GET_AMENITIES: "api/v1/admin/dropdown/amenties",
  GET_FACILITIES: "api/v1/admin/dropdown/facilites",
  GET_STATES: "api/v1/admin/dropdown/states",
  GET_CITY_BY_STATE_ID: "api/v1/admin/dropdown/cities",
};

export const ADMIN_CONTACT_US_ROUTES = {
  GET_ALL_CONTACT_US: "api/v1/admin/contact-us",
  DELETE_CONTACT_US: "api/v1/admin/contact-us",
  SEND_REPLY_CONTACT_US: "api/v1/admin/reply-contact-us",
};

export const ADMIN_SEO_ROUTES = {
  GET: "api/v1/admin/seo",
  POST: "api/v1/admin/seo",
};

export const ADMIN_FAQS = {
  GET_ALL_FAQS_CATEGORY: "api/v1/admin/faqs/categories",
  GET_ALL_FAQS: "api/v1/admin/faqs",
  ADD_FAQS: "api/v1/admin/faqs",
  UPDATE_FAQS: "api/v1/admin/faqs",
  UPDATE_STATUS_FAQS: "api/v1/admin/faqs",
  DELETE_FAQS: "api/v1/admin/faqs",
};

export const ADMIN_FEEDBACK = {
  GET_ALL_FEEDBACK: "api/v1/admin/feedback",
  GET_SINGLE_FEEDBACK: "api/v1/admin/feedback",
};

export const ADMIN_BUILDER = {
  GET_ALL_BUILDER: "api/v1/admin/builder",
  ADD_BUILDER: "api/v1/admin/builder",
  UPDATE_BUILDER: "api/v1/admin/builder",
  DELETE_BUILDER: "api/v1/admin/builder",
  CHANGE_STATUS: "api/v1/admin/builder",
};

export const ADMIN_ENQUIRY = {
  GET_ALL_ENQUIRY: "api/v1/admin/enquiry",
  DELETE_ENQUIRY: "api/v1/admin/enquiry",
  NEW_ENQUIRY: "api/v1/admin/enquiry",
};

export const ADMIN_PROJECT = {
  GET_ALL_PROJECT: "api/v1/admin/projects",
  CREATE_PROJECT: "api/v1/admin/projects",
  PROJECT_IMAGES: "api/v1/admin/projects/images",
  UPLOAD_RERA_DOCUMENT: "api/v1/admin/projects/rera-document",
  ASSING_AGENT_PROJECT: "api/v1/admin/projects/assign-agent",
  MULTIPLE_DELETE_PROJECT: "api/v1/admin/soft-delete-projects",
  PROJECT_IMAGE_POSITION: "api/v1/admin/projects/images/position",
};

export const ADMIN_CUSTOMER = {
  GET_ALL_CUSTOMER: "api/v1/admin/get-customer",
  ADD_CUSTOMER: "api/v1/admin/customer",
  DELETE_CUSTOMER: "api/v1/admin/customer",
  CHANGE_STATUS: "api/v1/admin/customer",
};

export const AGENT_MEETING_ROUTES = {
  GET_MEETING: "api/v1/admin/get-meeting",
  ACCEPT_MEETING: "api/v1/admin/set-slot",
  CANCEL_MEETING: "api/v1/admin/cancel-meeting",
  COMPLETE_MEETING: "api/v1/admin/complete-meeting",
  ADD_AVAILABILITY: "api/v1/admin/add-availability",
  GET_AVAILABILITY: "api/v1/admin/get-availability",
  ADD_UNAVAILABLE_DATE: "api/v1/admin/add-unavailable-date",
  DELETE_UNAVAILABLE_DATE: "api/v1/admin/remove-unavailable-date",
  UPDATE_UNAVAILABLE_DATE: "api/v1/admin/change-unavailable-date",
  GET_SALES_MEMBER_DROPDOWN: "api/v1/admin/leads/sales-member?meeting_id=",
};

export const AGENT_DASHBOARD_ROUTES = {
  AGENT_HEIGLIGHTS: "api/v1/admin/highlights-for-agent",
  RECENTLY_CLOSED_DEALS: "api/v1/admin/recent-closed-deals",
  AGENT_CHART_DATA: "api/v1/admin/agent-chart-data",
};

export const ADMIN_DASHBOARD = {
  PROPERTY_MANAGEMENT: "api/v1/admin/sold-unsold-count-for-admin",
  HIGHLIGHTS_FOR_ADMIN: "api/v1/admin/highlights-for-admin",
  TOP_AREA: "api/v1/admin/top-area",
};

export const ADMIN_LEADS_ROUTES = {
  LEAD: "api/v1/admin/leads",
};

export const SALES_LEADS_ROUTES = {
  CREATE_WALK_IN_LEAD: "api/v1/admin/leads/walk-in",
  GET_PROJECTS: "api/v1/admin/leads/projects",
  GET_PROPERTIES: "api/v1/admin/leads/properties",
};

export const BUILDER_AGENT_ROUTES = {
  FIND_AGENT: "api/v1/admin/dropdown/agents",
  ASSIGN_AGENT: "api/v1/admin/assign-builder-agent",
  UNASSIGN_AGENT: "api/v1/admin/unassign-builder-agent",
};

export const BUILDER_SALES_TEAM_ROUTES = {
  GET_SALES_TEAM: "api/v1/admin/sales-member",
  DELETE_SALES_MEMBER: "api/v1/admin/delete-sales-member",
  GET_SALES_MEMBER_SUMMERY: "api/v1/admin/sales-member-summery",
  GET_SALES_TEAM_LOCATION_HISTORY: "api/v1/admin/get-location",
};

export const ADMIN_REELS_ROUTES = {
  GET_ALL_REELS: "api/v1/admin/reels/list",
  UPDATE_STATUS: "api/v1/admin/reels",
  DELETE_REELS: "api/v1/admin/reels",
  MULTIPLE_DELETE_REELS: "api/v1/admin/delete-multiple-reels",
};

export const ADMIN_SLIDER_ROUTES = {
  GET_ALL_SLIDER: "api/v1/admin/slider",
  ADD_SLIDER: "api/v1/admin/slider",
  UPDATE_SLIDER: "api/v1/admin/slider",
  DELETE_SLIDER: "api/v1/admin/slider",
};

export const ADMIN_NOTIFICATION_ROUTES = {
  GET_ALL_NOTIFICATION: "api/v1/admin/notification",
  ADD_NOTIFICATION: "api/v1/admin/notification",
  DELETE_NOTIFICATION: "api/v1/admin/notification",
};

export const ADMIN_REPORTS_ROUTES = {
  GET_ALL_REPORT: "api/v1/admin/report",
  UPDATE_REPORT: "api/v1/admin/report",
};

export const ADMIN_FAQS_CATEGORY_ROUTES = {
  GET_ALL_FAQS_CATEGORY: "api/v1/admin/faqs/categories",
  CREATE_FAQS_CATEGORY: "api/v1/admin/faqs/categories",
  UPDATE_FAQS_CATEGORY: "api/v1/admin/faqs/categories",
  DELETE_FAQS_CATEGORY: "api/v1/admin/faqs/categories",
  MULTIPLE_DELETE_FACT_CATEGORY: "api/v1/admin/faqs/delete-multiple-categories",
};

export const ADMIN_GROUP_NAME_ROUTES = {
  GET_ALL_GROUPS: "api/v1/admin/group-name",
  CREATE_GROUP: "api/v1/admin/group-name",
  UPDATE_GROUP: "api/v1/admin/group-name",
  MULTIPLE_DELETE_GROUP: "api/v1/admin/delete-multiple-group-name",
};

export const SALES_DASHBOARD_ROUTES = {
  GET_HEIGH_LIGHTS: "api/v1/admin/leads/highlights",
  GET_LEAD_MANAGEMENT: "api/v1/admin/leads/lead-management",
};

export const ADMIN_ADVERTISE_ROUTERS = {
  GET_ALL_ADVERTISE: "api/v1/admin/advertise",
};

export const ADMIN_SALES_RECORDS_ROUTERS = {
  GET_ALL_SALES_RECORDS: "api/v1/admin/sales-data",
  DELETE_RECORDS: "api/v1/admin/sales-data",
};

export const BUILDER_DASHBOARD_ROUTES = {
  GET_SUMMARY: "api/v1/admin/highlights-for-builder",
  GET_SALES_TEAM_PERFORMANCE: "api/v1/admin/recent-close-summery",
  GET_AGENT_SALES_TEAM: "api/v1/admin/agent-sales-team",
  GET_SALES_TEAM: "api/v1/admin/sales-team",
  GET_PROJECT_PERFORMANCE_STAGE: "api/v1/admin/builder-chart-data",
};

export const ADMIN_AREA_ROUTES = {
  GET_AREA_ALL_LIST: "api/v1/admin/area-all",
  GET_AREA_LIST: "api/v1/admin/area",
  POST_NEW_AREA: "api/v1/admin/area",
  DELETE_AREA: "api/v1/admin/area",
};

export const ADMIN_WHATSAPP_ROUTERS = {
  SEND_MSG: "api/v1/admin/whatsapp",
  GET_TEMPLATE_LIST: "api/v1/admin/get-template-name",
  GET_TEMPLATES_LIST_DETAILS: "api/v1/admin/get-all-whatsapp-template",
};

export const ADMIN_WHATSAPP_ANALYTICS_ROUTERS = {
  GET_LIST: "api/v1/admin/whatsapp-summary",
};

export const ADMIN_BOOK_CALL_ROUTERS = {
  GET_LIST: "api/v1/admin/book-call",
};
